const CardHeader = {
	baseStyle: {
		fontSize: '20px',
		fontWeight: 'bold',
		display: "flex",
		width: "100%",
		marginBottom: '20px'
	},
};

export const CardHeaderComponent = {
	components: {
		CardHeader,
	},
};
